import { render, staticRenderFns } from "./Classroom_new_text_detial.vue?vue&type=template&id=a62ef99a&scoped=true"
import script from "./Classroom_new_text_detial.vue?vue&type=script&lang=js"
export * from "./Classroom_new_text_detial.vue?vue&type=script&lang=js"
import style0 from "./Classroom_new_text_detial.vue?vue&type=style&index=0&id=a62ef99a&prod&scoped=true&lang=less"
import style1 from "./Classroom_new_text_detial.vue?vue&type=style&index=1&id=a62ef99a&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a62ef99a",
  null
  
)

export default component.exports